export const localTranslations = {
  ru: {
    "toast.create_task_success": "Задача на выгрузку создана",
    "toast.create_task_failed": "Не удалось создать задачу на выгрузку",
    "toast.download_task_failed": "Не удалось скачать файл",
    "toast.download_task_completed": "Файл успешно скачан",
    "toast.download_task_started_5000":
      'Началось скачивание отчета "{reportName}". Проверить статус можно в «<u>Истории выгрузок</u>»',
    "news_page_toolbar.banner.page_selected":
      "Выбраны новости на нескольких страницах.",
    "news_page_toolbar.banner.single_page_selected":
      "Выбраны новости на одной странице.",
    "news_page_toolbar.banner.select_all": "Выбрать все",
    "news_page_toolbar.banner.news.one": "новость?",
    "news_page_toolbar.banner.news.few": "новости?",
    "news_page_toolbar.banner.news.many": "новостей?",
    "news_page_toolbar.banner.accept": "Выбрать",
    "news_page_toolbar.banner.close": "Закрыть",
  },
  en: {
    "toast.create_task_success": "Export task created",
    "toast.create_task_failed": "Failed to create export task",
    "toast.download_task_failed": "Failed to download the file",
    "toast.download_task_completed": "File downloaded successfully",
    "toast.download_task_started_5000":
      'Download report "{reportName}" started. You can check the status in "History of exports"',
    "news_page_toolbar.banner.page_selected":
      "News on multiple pages are selected.",
    "news_page_toolbar.banner.single_page_selected":
      "News on one page are selected.",
    "news_page_toolbar.banner.select_all": "Select all",
    "news_page_toolbar.banner.news.one": "news?",
    "news_page_toolbar.banner.news.few": "news?",
    "news_page_toolbar.banner.news.many": "news?",
    "news_page_toolbar.banner.accept": "Select",
    "news_page_toolbar.banner.close": "Close",
  },
  fr: {
    "toast.create_task_success": "Tâche d'export créée",
    "toast.create_task_failed": "Impossible de créer la tâche d'export",
    "toast.download_task_failed": "Impossible de télécharger le fichier",
    "toast.download_task_completed": "Fichier téléchargé avec succès",
    "toast.download_task_started_5000":
      'Téléchargement du rapport "{reportName}" démarré. Vous pouvez vérifier le statut dans "Historique des exports"',
    "news_page_toolbar.banner.page_selected":
      "Les actualités de plusieurs pages sont sélecti onnées.",
    "news_page_toolbar.banner.single_page_selected":
      "Les actualités d'une page sont sélectionnées.",
    "news_page_toolbar.banner.select_all": "Tout sélectionner",
    "news_page_toolbar.banner.news.one": "actualités ?",
    "news_page_toolbar.banner.news.few": "actualités ?",
    "news_page_toolbar.banner.news.many": "actualités ?",
    "news_page_toolbar.banner.accept": "Sélectionner",
    "news_page_toolbar.banner.close": "Fermer",
  },
  es: {
    "toast.create_task_success": "Tarea de exportación creada",
    "toast.create_task_failed": "No se pudo crear la tarea de exportación",
    "toast.download_task_failed": "No se pudo descargar el archivo",
    "toast.download_task_completed": "Archivo descargado correctamente",
    "toast.download_task_started_5000":
      'Descarga del informe "{reportName}" iniciada. Puede verificar el estado en "Historial de exportaciones"',
    "news_page_toolbar.banner.page_selected":
      "Están seleccionadas las noticias de varias páginas.",
    "news_page_toolbar.banner.single_page_selected":
      "Están seleccionadas las noticias de una página.",
    "news_page_toolbar.banner.select_all": "Seleccionar todas",
    "news_page_toolbar.banner.news.one": "noticias?",
    "news_page_toolbar.banner.news.few": "noticias?",
    "news_page_toolbar.banner.news.many": "noticias?",
    "news_page_toolbar.banner.accept": "Seleccionar",
    "news_page_toolbar.banner.close": "Cerrar",
  },
};
